<template>
	<div class="wrapper">
		<v-container
			text-xs-center
			grid-list-sm
			class="identify-stockist-filter-switches"
		>
			<v-layout justify-center row wrap>
				<v-flex xs12 sm12 md3>
					<v-switch
						v-model="showHiddenFiles"
						@change="handleShowHiddenFilesChange"
						:label="`Show Hidden Files`"
					></v-switch>
					<v-switch
						v-model="showAIPredictedFiles"
						@change="handleShowHiddenFilesChange"
						:label="`Show AI Predicted Files`"
					></v-switch>
				</v-flex>
				<v-flex xs12 sm12 md3>
					<v-select
						persistent-hint
						hint="Select File Extension"
						color="yellow darken-3"
						:items="fileExtensions"
						label="File Extensions"
						v-model="extension"
					></v-select>
				</v-flex>
				<v-flex xs12 sm12 md5>
					<v-text-field
						persistent-hint
						hint="Enter Text to Filter by"
						color="yellow darken-3"
						label="Filter Text"
						v-model="filterText"
					></v-text-field>
				</v-flex>
			</v-layout>
		</v-container>
		<v-container
			class="identify-stockist-filter-action-buttons"
			text-xs-center
			grid-list-sm
		>
			<v-layout justify-center row wrap>
				<v-flex xs6 sm6 md3>
					<v-btn @click="filterStockist" flat color="orange darken-1" large
						>Filter</v-btn
					>
				</v-flex>
				<v-flex xs6 sm6 md3 @click="refreshStockistList">
					<v-btn color="pink" flat>Reset Filter</v-btn>
				</v-flex>
			</v-layout>
		</v-container>
		<code>No. of files: {{ getFileCount }}</code>
		<v-expansion-panel>
			<v-expansion-panel-content
				v-for="(item, stkIndex) of Object.keys(mailMeta)"
				:key="item"
			>
				<template v-slot:header>
					<div class="font-weight-light pa-2">
						<span class="headline">
							Sender Id: - {{ stkIndex + 1 }}.
							{{ mailMeta[item][0] ? mailMeta[item][0].sender : '' }}
							<v-btn
								@click.stop="forceHideAll(item)"
								outline
								color="red darken-3"
								>Force Hide</v-btn
							>
						</span>
						<br />
						<!-- <span class="subheader">Date: - {{getFormattedDate(mailMeta[item][0].date)}}</span> -->
						<!-- <br /> -->
						<span class="subheader">Files: - {{ mailMeta[item].length }}</span>
					</div>
				</template>
				<v-card flat>
					<v-card-text>
						<v-list two-line subheader>
							<v-list-tile
								v-for="(file, index) in mailMeta[item]"
								:key="file._id"
								@click="openFileMetaModal(file)"
							>
								<v-list-tile-action>
									<v-icon @click.stop="clearLock(file)">lock_open</v-icon>
								</v-list-tile-action>
								<v-list-tile-content>
									<v-list-tile-title :style="{ height: 'auto' }"
										>File name: - {{ index + 1 }}.
										{{ file.filename }}
										<v-btn
											outline
											small
											color="red darken-3"
											@click.stop="forceHideFile(file)"
											>Force Hide</v-btn
										>
									</v-list-tile-title>
									<v-list-tile-sub-title
										>Original file name: -
										{{ file.originalFilename }}
									</v-list-tile-sub-title>
									<v-list-tile-sub-title
										>Date: -
										{{ getFormattedDate(file.date) }}
										<span v-if="'subject' in file && file.subject">
											| Sub: - {{ file.subject }}
										</span>
									</v-list-tile-sub-title>
								</v-list-tile-content>
								<v-list-tile-action>
									<v-icon>keyboard_arrow_right</v-icon>
								</v-list-tile-action>
							</v-list-tile>
						</v-list>
					</v-card-text>
				</v-card>
			</v-expansion-panel-content>
		</v-expansion-panel>
		<div class="mt-1 mb-1 text-xs-center">
			<v-pagination
				color="yellow darken-3"
				prev-icon="navigate_before"
				next-icon="navigate_next"
				v-model="page"
				:total-visible="5"
				:length="paginationLength"
				@input="updatePage"
			></v-pagination>
		</div>
		<v-btn
			@click="refreshStockistList"
			color="pink"
			fab
			dark
			fixed
			small
			bottom
			right
		>
			<v-icon>autorenew</v-icon>
		</v-btn>
		<FileMetaModal v-if="fileMetaEditorDialog" />
	</div>
</template>

<script>
import FileMetaModal from './fileMetaModal';
import moment from 'moment-timezone';
import { mapGetters, mapActions, mapMutations } from 'vuex';
export default {
	data() {
		return {
			page: 1,
			paginationLength: 10,
			filterText: '',
			extension: false,
			fileExtensions: [
				{ text: 'All', value: false },
				...require('../../components/extensions.json'),
			],
			showHiddenFiles: false,
			showAIPredictedFiles: false,
		};
	},
	components: {
		FileMetaModal,
	},
	created() {
		this.getStockistList({
			pageNo: 1,
			pageSize: Infinity,
			text: '',
		}).then(data => {
			if (data.ok) {
				this.setStockistList(data.stockists);
			} else {
				this.openSnackbar({
					text: 'Could not load Stockist list',
				});
			}
		});
		this.fetchMailMeta();
	},
	methods: {
		...mapActions(['getStockistList']),
		...mapActions('identifyStockist', ['getMailMeta', 'hideFileForMapping']),
		...mapActions('fileExtraction', ['lockFile', 'unlockFile']),
		...mapMutations('identifyStockist', [
			'openFileMetaDialog',
			'setSelectedFile',
			'setStockistList',
		]),
		...mapMutations(['openLoaderDialog', 'closeLoaderDialog', 'openSnackbar']),
		openFileMetaModal(item) {
			this.lockFile(item._id).then(data => {
				if (!data) {
					this.setSelectedFile(item);
					this.openFileMetaDialog();
					// Auto-trigger Generate AI Stockist if toggle is on and file has AI data
					if (this.showAIPredictedFiles && item.AI_predicted_stockist_id) {
						// Use $nextTick to ensure the dialog is opened before triggering AI generation
						this.$nextTick(() => {
							// Emit event to trigger Generate AI Stockist in the editor
							this.$store.commit('identifyStockist/triggerGenerateAIStockist', true);
						});
					}
				} else {
					this.openSnackbar({
						text: 'File is being edited by someone else',
					});
				}
			});
			// this.setSelectedFile(item);
			// this.openFileMetaDialog();
		},
		fetchMailMeta() {
			this.openLoaderDialog();
			this.getMailMeta({
				pageNo: this.page,
				pageSize: 20,
				text: this.filterText,
				extension: this.extension,
				...this.getSelectedDates,
				showHiddenFiles: this.showHiddenFiles,
				showAIPredictedFiles:this.showAIPredictedFiles
			}).then(data => {
				this.closeLoaderDialog();
				if (data) {
					// console.log(data);
					this.paginationLength = Math.ceil(data.length / 20);
					console.log('Loaded mail meta');
				} else {
					console.log('Failed to load mail meta');
				}
			});
		},
		refreshStockistList() {
			this.page = 1;
			(this.filterText = ''), (this.extension = false), this.fetchMailMeta();
		},
		handleShowHiddenFilesChange() {
			this.fetchMailMeta();
		},
		updatePage() {
			this.fetchMailMeta();
		},
		filterStockist() {
			this.fetchMailMeta();
		},
		getFormattedDate(date) {
			return moment(date)
				.tz('Asia/Kolkata')
				.format('DD-MMM-YYYY');
		},
		clearLock(file) {
			this.unlockFile(file._id).then(data => {
				if (!data) {
					this.openSnackbar({
						text: 'Cleared File lock',
					});
				} else {
					this.openSnackbar({
						text: 'Could not clear file lock',
					});
				}
			});
		},
		forceHideAll(item) {
			let uuids = this.mailMeta[item].map(e => e.uuid);
			if (window.confirm('Are you sure you want to extract this file??????')) {
				this.hideFileForMapping({
					uuids,
				}).then(data => {
					if (data) {
						this.refreshStockistList();
					} else {
						this.openSnackbar({
							text: 'Failed to hide files please try again.',
						});
					}
				});
			}
		},
		forceHideFile(item) {
			if (
				window.confirm(
					`Are you sure you want to hide '${item.filename || 'this file'}'`
				)
			) {
				this.hideFileForMapping({
					uuids: [item.uuid],
				}).then(data => {
					if (data) {
						this.refreshStockistList();
					} else {
						this.openSnackbar({
							text: 'Failed to hide files please try again.',
						});
					}
				});
			}
		},
	},
	computed: {
		...mapGetters(['getSelectedDates', 'selectedDates']),
		...mapGetters('identifyStockist', ['fileMetaEditorDialog', 'mailMeta']),
		getFileCount() {
			let count = 0;
			for (let i in this.mailMeta) {
				count += this.mailMeta[i].length;
			}
			return count;
		},
	},
	mounted() {
		this.$store.subscribe(mutation => {
			if (mutation.type === 'identifyStockist/refreshStockistListEmitter') {
				this.refreshStockistList();
				this.getStockistList({
					pageNo: 1,
					pageSize: Infinity,
					text: '',
				}).then(data => {
					if (data.ok) {
						this.setStockistList(data.stockists);
					} else {
						this.openSnackbar({
							text: 'Could not load Stockist list',
						});
					}
				});
			}
			// Listen for modal close event to refresh data with current toggle states
			if (mutation.type === 'identifyStockist/closeFileMetaDialog') {
				this.fetchMailMeta();
			}
		});
	},
	watch: {
		selectedDates() {
			// console.log(nv, cv);
			this.refreshStockistList();
		},
	},
};
</script>

<style lang="scss" scoped>
.container.identify-stockist-filter-switches.text-xs-center.grid-list-sm {
	padding-bottom: 0;
}

.identify-stockist-filter-action-buttons.container.text-xs-center.grid-list-sm {
	padding: 0;
}
> .v-pagination >>> li button {
	width: 100%;
	min-width: 35px;
}

.v-card__text {
	padding: 0px;
}
</style>